// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1Ziz-","additionalInfo":"AgreementModal_additionalInfo__2SwD_"};